/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Medal(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Circle cx={127.99414} cy={96} r={56} />
        <Path d="M127.99414,8A87.96624,87.96624,0,0,0,72,163.8374V240a7.99951,7.99951,0,0,0,11.57812,7.15527l44.415-22.21093,44.42969,22.21142A8,8,0,0,0,184,240V163.82764A87.96617,87.96617,0,0,0,127.99414,8Zm0,160a72,72,0,1,1,72-72A72.08124,72.08124,0,0,1,127.99414,168Z" />
      </G>
    </Svg>
  );
}

export default Medal;
